const num=v=>Number.isFinite(Number(v))?Number(v):null;
const day=v=>{const t=+new Date(v||0);return Number.isFinite(t)&&t>0?new Date(t).toISOString().slice(0,10):null};

export function deriveSectorTurnEvents(sectorBreadth={}){
  const health=String(sectorBreadth?.health?.status||'MISSING').toUpperCase();
  if(health!=='LIVE')return{status:health,events:[],count:0,note:'Sector-turn alerts require LIVE breadth health; stale or missing breadth cannot trigger a turn event.'};
  const events=[];
  for(const s of sectorBreadth?.sectors||[]){
    if(!s?.previous||!s?.latest)continue;
    const asOf=s.latest?.as_of||s.latest?.observed_at||null;
    const prevAsOf=s.previous?.as_of||s.previous?.observed_at||null;
    if(s.newlyWeak){
      events.push({
        eventKey:`${s.key}:TURNED_WEAK:${day(asOf)||'unknown'}`,
        sectorKey:s.key,
        sectorName:s.name||s.key,
        eventType:'TURNED_WEAK',
        severity:(s.deterioration||0)>=4?'HIGH':'MEDIUM',
        asOf,
        previousAsOf:prevAsOf,
        acceleration:num(s.acceleration),
        relativeStrength:num(s.relativeStrength),
        capitalFlow:num(s.capitalFlow),
        deterioration:s.deterioration||0,
        reason:'Latest verified sector snapshot changed from not weak to weak.'
      });
    }else if(s.newlyHealthy){
      events.push({
        eventKey:`${s.key}:TURNED_HEALTHY:${day(asOf)||'unknown'}`,
        sectorKey:s.key,
        sectorName:s.name||s.key,
        eventType:'TURNED_HEALTHY',
        severity:'INFO',
        asOf,
        previousAsOf:prevAsOf,
        acceleration:num(s.acceleration),
        relativeStrength:num(s.relativeStrength),
        capitalFlow:num(s.capitalFlow),
        deterioration:s.deterioration||0,
        reason:'Latest verified sector snapshot changed from weak to not weak.'
      });
    }
  }
  events.sort((a,b)=>String(b.asOf||'').localeCompare(String(a.asOf||''))||String(a.sectorKey).localeCompare(String(b.sectorKey)));
  return{status:'LIVE',events,count:events.length,note:'Turn events are evidence changes from consecutive verified sector snapshots. They are market context, not trade signals.'};
}
